import { DataSource } from "@angular/cdk/collections";
import { User } from "common/class/user";
import { Logger } from "common/utility/logger/logger";
import { BehaviorSubject, catchError, finalize, Observable, of, Subject, takeUntil } from "rxjs";
import { EdgeDeviceService } from "services/edge-device/edge-device.service";


export class EdgeDeviceDataSource implements DataSource<any> {

    private edgeDevices = new BehaviorSubject<Array<any>>([]);
    private loading = new BehaviorSubject<boolean>(false);
    private unsubscribe: Subject<void> = new Subject()

    public get EdgeDevices(): Observable<Array<any>> {
        return this.edgeDevices.asObservable()
    }

    public get Loading(): Observable<boolean> {
        return this.loading.asObservable()
    }

    public connect(): Observable<any[]> {
        // this.watchDataChanges()
        return this.edgeDevices.asObservable();
    }

    public disconnect(): void {
        this.loading.complete();
    }

    public loadEdgeDevices(): void {
        this.loading.next(true);

        this.edgeDeviceService.list().pipe(
            catchError(() => of([])),
            takeUntil(this.unsubscribe),
            finalize(() => this.loading.next(false))
        ).subscribe(edgeDevices => {
            Logger.debug(`Received new EdgeDevices`,edgeDevices)
            this.loading.next(false)
            return this.edgeDevices.next(edgeDevices)
        });
    }

    public sorted(users: Array<User>): void {
        this.edgeDevices.next(users)
    }

    public destroy(): void {
        this.unsubscribe.next()
        this.unsubscribe.complete()
    }

    constructor(
        private edgeDeviceService: EdgeDeviceService,
    ) { }
}